import {Component, Input} from "@angular/core";

@Component({
  selector: "admin-panel-standard",
  templateUrl: "./standard.component.html",
  styleUrls: ["./standard.component.css"]
})
export class AdminPanelStandardComponent {

  @Input() title: string = "";
  @Input() border: string = "";
  @Input() customs: string = "";

}
